// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__1fRK8","actionColumn":"ReferralSources_actionColumn__DAt7p","textButton":"ReferralSources_textButton__3XOvX"};